
export interface NavEvent {
	action: string;
	historical: boolean;
	internal: boolean;
}

export class NavEvents {
	public static New(act: string): NavEvent {
		return { action: act, historical: false, internal: false };
	}
	public static NewHistorical(act: string): NavEvent {
		return { action: act, historical: true, internal: false };
	}
	public static NewInternal(act: string): NavEvent {
		return { action: act, historical: false, internal: true };
	}

}